import { apiRequest } from '../api/ApiRequest';


// import { jsonDateParser } from "json-date-parser";



const UPDATE_REGISTEREDRECORDOVERVIEW_STORY = 'upload/UPDATE_REGISTEREDRECORDOVERVIEW_STORY';
const UPDATE_DEREGISTEREDRECORDOVERVIEW_STORY = 'upload/UPDATE_DEREGISTEREDRECORDOVERVIEW_STORY';
const UPDATE_REPRESENTATIVE = 'upload/UPDATE_REPRESENTATIVE';


const BASE_URL = process.env.REACT_APP_DEBTDEFAULT_API_URL + '/upload';




export const updateRepresentative = representativeRegno => async dispatch => {
  dispatch({
    type: UPDATE_REPRESENTATIVE,
    data: representativeRegno
  });
};


export const loadRegisteredRecordOverview = representativeRegno => async dispatch => {
  // dispatch({ type: LOADING_CALCULATION_PACKAGE });
  const data = await apiRequest(`${BASE_URL}/RegisteredRecordOverview/${representativeRegno}`);
  if (!data.error) {
    dispatch({
      type: UPDATE_REGISTEREDRECORDOVERVIEW_STORY,
      data: data || []
    });
  }
  // dispatch({ type: LOADED_CALCULATION_PACKAGE });
  return data;
};

export const loadDeRegisteredRecordOverview = representativeRegno => async dispatch => {
  // dispatch({ type: LOADING_CALCULATION_PACKAGE });
  const data = await apiRequest(`${BASE_URL}/DeRegisteredRecordOverview/${representativeRegno}`);
  if (!data.error) {
    dispatch({
      type: UPDATE_DEREGISTEREDRECORDOVERVIEW_STORY,
      data: data || []
    });
  }
  // dispatch({ type: LOADED_CALCULATION_PACKAGE });
  return data;
};



const initialState = {
  representativeRegno : undefined,
  registerRecordOverviewList: [],
  deRegisterRecordOverviewList: []
};


export default (state = initialState, action) => {
  if (action.data === null) {
    return state;
  }
  switch (action.type) {
    case UPDATE_REGISTEREDRECORDOVERVIEW_STORY: {
      return {
        ...state,
        registerRecordOverviewList: action.data
      };
    }
    case UPDATE_DEREGISTEREDRECORDOVERVIEW_STORY: {
      return {
        ...state,
        deRegisterRecordOverviewList: action.data
      };
    }
    case UPDATE_REPRESENTATIVE: {
      return {
        ...state,
        representativeRegno: action.data
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/ducks/ddupload.js